import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import styles from "components/documents/no-documents.scss";

const APP_STORE_URL = "https://itunes.apple.com/au/app/shoeboxed-australia-document/id1044924996?mt=8";
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=au.com.shoeboxed.android";
const REJECTION_SUPPORT_URL = `https://support.squirrelstreet.com/support/solutions/articles/
  24000015064-one-of-my-documents-was-rejected-what-do-i-do-`;

export const NoDocuments = ({ accountSlug, totalCount }) => (
  totalCount === 0 ? blankSlate(accountSlug) : noResults()
);

NoDocuments.propTypes = {
  accountSlug: PropTypes.string.isRequired,
  totalCount: PropTypes.number.isRequired
};

export const NoPending = ({ accountSlug }) => (
  <div className={ styles["no-pending"] }>
    <h2>Looks like you don’t have any documents squirreling away at the moment!</h2>
    <h3>
      Want to upload documents? Simply click
      &nbsp;<Link to={ `/accounts/${accountSlug}/upload` }>here</Link>
      &nbsp;and drag your files into the box.
    </h3>
    <h4>What’s this page about?</h4>
    <div>
      It contains all your digital submissions awaiting processing.
       Those include documents that you have emailed, uploaded from
       your computer or snapped from your phone using our mobile app.
       Once they are processed by our team of operators or manually by yourself,
       they will automatically disappear from this list.
    </div>
    <h4>What can I do on this page?</h4>
    <div>
      <ul>
        <li>
          Check that your digital submissions made it through to Squirrel Street.
           You can also view their image here, so easy to see if you sent the same one twice by mistake
        </li>
        <li>
          Enjoy our DIY feature. This is a great option for users on our DIY plan.
           You can submit an unlimited number of digital documents and manually enter them at no cost:
          <ol>
            <li>Click on a document to the left to select it</li>
            <li>
              If the document is a document, fill in the details in the fields below.
               If the document is another document, click on &apos;Change type&apos;.
            </li>
            <li>Click on &apos;Save&apos; at the bottom, and the document will go into the account.</li>
          </ol>
        </li>
      </ul>
    </div>
    <h4>You thought you uploaded a document but you can’t see it here?</h4>
    <div>
      Check your mails for a rejection notice. Indeed, you’ll receive an email
       notification when your document is blurry, multiple tax invoices have been scanned
       in as one document without total amount paid, or your document is incomplete or cropped
       such that we can&apos;t extract fields such as Vendor name or Total.
    </div>
    <div>Check out our <a href={ REJECTION_SUPPORT_URL }>What to do after a rejection notice</a> FAQ.</div>
  </div>
);

NoPending.propTypes = {
  accountSlug: PropTypes.string.isRequired
};

export const NoPendingFiltered = () => (
  <div className={ styles["no-pending"] }>
    <h2>Oops!</h2>
    <div>
      There are no documents that match the selected filters.
    </div>
  </div>
);

const blankSlate = (accountSlug) => (
  <div className={ styles["blank-slate"] }>
    <h3>Darn! Looks like you haven&#39;t squirreled away any documents yet!</h3>
    { blankSlateText(accountSlug) }
  </div>
);

const noResults = () => (
  <div className={ styles["no-results"] }><h3>No documents found</h3></div>
);

const blankSlateText = (accountSlug) => (
  <p>
  Use the <a href={ APP_STORE_URL }>iOS</a> or <a href={ PLAY_STORE_URL }>Android</a> mobile apps to capture and
  submit a document, or upload a document directly from your computer on&nbsp;
  <Link to={ `/accounts/${accountSlug}/upload` }>the submit page</Link>.
  Your documents will be listed here once processed and ready.
  </p>
);




// WEBPACK FOOTER //
// ./src/js/components/documents/documents-grid/no-documents.jsx